var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchukoSmallDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24C18.5 25.933 16.933 27.5 15 27.5C13.067 27.5 11.5 25.933 11.5 24C11.5 22.067 13.067 20.5 15 20.5C16.933 20.5 18.5 22.067 18.5 24Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 24C36.5 25.933 34.933 27.5 33 27.5C31.067 27.5 29.5 25.933 29.5 24C29.5 22.067 31.067 20.5 33 20.5C34.933 20.5 36.5 22.067 36.5 24Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5438 19.0449V20.0449H44.5438H45.9263C46.5383 20.0449 47 20.5308 47 21.0674V26.9326C47 27.4692 46.5383 27.9551 45.9263 27.9551H44.5438H43.5438V28.9551V34.2779C40.3337 40.0614 34.489 44.2624 27.5685 45.3584C27.4914 43.4558 25.8908 41.9742 23.9793 41.9742C22.0677 41.9742 20.4671 43.4558 20.39 45.3585C13.469 44.263 7.62452 40.0672 4.41475 34.2782V28.9551V27.9551H3.41475H2.07373C1.46172 27.9551 1 27.4692 1 26.9326V21.0674C1 20.5308 1.46172 20.0449 2.07373 20.0449H3.41475H4.41475V19.0449V13.7221C7.63742 7.91584 13.5155 3.7045 20.4718 2.62877C20.61 3.47672 20.9217 4.17228 21.4374 4.69101C22.17 5.42781 23.1286 5.62135 23.9793 5.62135C24.8343 5.62135 25.7916 5.42233 26.5223 4.68469C27.0361 4.16611 27.3476 3.47226 27.4862 2.6278C34.4424 3.69759 40.3209 7.90904 43.5438 13.7218V19.0449Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchukoSmallDark);
export default __webpack_public_path__ + "static/media/schuko_small_dark.7bd6c254c73497da6ebc4a82ab788caf.svg";
export { ForwardRef as ReactComponent };